"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJsonpRequest = void 0;
const react_1 = require("react");
const utils_1 = require("../utils");
function useJsonpRequest(url, onBeforeLoad, onError, onLoad) {
    const [response, setResponse] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        let unmounted = false;
        let script;
        const removeScript = () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
        const request = new Promise((resolve, reject) => {
            const jsonpCallback = encodeURIComponent(`revjet_${(0, utils_1.generateUniqueId)()}`);
            const requestUrl = `${url}&jsonp=${jsonpCallback}`;
            script = document.createElement('script');
            window[jsonpCallback] = (response) => {
                ;
                window[jsonpCallback] = undefined;
                removeScript();
                if (unmounted) {
                    reject(new Error(`Unmounted component`));
                }
                else {
                    resolve(response);
                }
            };
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('importance', 'high');
            script.src = requestUrl;
            script.onerror = () => {
                removeScript();
                reject(new Error(`Error while requesting tag`));
            };
            if (onBeforeLoad) {
                onBeforeLoad();
            }
            const headTags = document.getElementsByTagName('head');
            if (headTags.length > 0) {
                headTags[0].appendChild(script);
            }
            else {
                const scriptTags = document.getElementsByTagName('script');
                if (scriptTags.length > 0) {
                    scriptTags[0].parentNode.insertBefore(script, scriptTags[0].nextSibling);
                }
                else {
                    reject(new Error(`Can't insert script tag`));
                }
            }
        });
        request
            .then((response) => {
            if (unmounted) {
                throw new Error(`Unmounted component`);
            }
            else {
                if (onError && (response.failover_url || response.failover_query_string)) {
                    onError(new Error(`The content server returned an error: ${response.failover_url || response.failover_query_string}`));
                }
                else {
                    setResponse(response);
                    if (onLoad) {
                        onLoad(response);
                    }
                }
            }
        })
            .catch((e) => {
            if (unmounted) {
                console.error(e);
            }
            else if (onError) {
                onError(e instanceof Error ? e : new Error(String(e)));
            }
        });
        return () => {
            removeScript();
            unmounted = true;
        };
    }, [url, onBeforeLoad, onError, onLoad]);
    return response;
}
exports.useJsonpRequest = useJsonpRequest;
//# sourceMappingURL=use-jsonp-request.js.map